import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const urlBase64ToUint8Array = (base64String) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

// Registers the service worker and subscribes this device to FUNZ push notifications.
// Silently no-ops where unsupported (iOS Safari before 16.4, non-installed PWAs, etc.)
export const initPush = async () => {
  try {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
    if (Notification.permission === "denied") return;
    const reg = await navigator.serviceWorker.register("/sw.js");
    const { data } = await axios.get(`${API}/push/vapid-key`);
    if (!data.public_key) return;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return;
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.public_key),
      });
    }
    await axios.post(
      `${API}/push/subscribe`,
      sub.toJSON(),
      { headers: { Authorization: `Bearer ${localStorage.getItem("funz_token")}` }, withCredentials: true }
    );
  } catch {
    // push is best-effort; never block the app
  }
};
